import {
  ApacCandidateHeader,
  ApacCandidateHeaderFooterLinkProvider,
} from '@seek/apac-candidate-header-footer';
import { useMelwaysInfo } from '@seek/melways-react';
import { useLocation } from 'react-router-dom';

import { getLanguageSwitcher } from 'src/modules/melways/utils';
import type { UserProfile } from 'src/types';

import type { ApacHeaderFooterAuthenticationStatus } from '../App/App';

interface headerProps {
  authenticationStatus: ApacHeaderFooterAuthenticationStatus;
  userProfile: UserProfile;
}

const Header = ({ authenticationStatus, userProfile }: headerProps) => {
  const customLinkComponent = {
    sendLinkEvent: () => {},
  };

  const { pathname } = useLocation();
  const { country } = useMelwaysInfo();

  return (
    <ApacCandidateHeaderFooterLinkProvider value={customLinkComponent}>
      <ApacCandidateHeader
        languageSwitcher={getLanguageSwitcher(country, pathname)}
        authenticationStatus={authenticationStatus}
        widthMode="large"
        userProfile={userProfile}
        activeAuthedUserTab="settings"
      />
    </ApacCandidateHeaderFooterLinkProvider>
  );
};

export default Header;
